// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--2KtsY","logoHolder":"Footer-module--logoHolder--2819Y","shamrock":"Footer-module--shamrock--2g3RL"};